SP.branches = {
  query: {
    location: null,
    maxRecord: null,
    selectedCity: null,
    filters: [],
    page: 0,
    buildFacets: false,
  },
  fetchBranches: (query, callback, applyDistanceLimit) => {
    query.ignoreDistanceLimit = applyDistanceLimit === true ? false : true

    // $.get(SP.config.branchFilterUrl, query, callback)
    $.get(SP.config.branchFilterUrl, query, (data) => {
      callback(data)
    })
  },
  getMetadata: (location, callback, maxResults) => {
    SP.branches.updateQueryFromURL(location, maxResults)
    SP.branches.fetchBranches(SP.branches.getQueryObject(), callback)
  },
  filterResults: (
    filters,
    selectedCity,
    location,
    maxResults,
    callback,
    applyDistanceLimit
  ) => {
    const counter = $('#resultsCounter')
    const container = $('#results-boxes')
    const $citySelect = $(branches.citySelect)
    const citySummery = $('#results-city')
    SP.branches.updateQuery(
      location,
      isMobile ? maxResults : null,
      selectedCity,
      filters,
      isMobile ? false : true,
      false
    )
    const query = SP.branches.getQueryObject()

    if (isMobile) {
      SP.branches.fetchBranches(
        query,
        (data) => {
          if (query.q) {
            history.pushState(query, null, '?q=' + query.q)
          }

          callback(
            data.storeList,
            data.pagination.totalNumberOfResults,
            selectedCity,
            location,
            data.pagination.numberOfPages - 1 > data.pagination.currentPage,
            container,
            counter,
            $citySelect
          )
        },
        applyDistanceLimit
      )
    } else {
      $.get(SP.config.branchFilterUrl, query, (data) => {
        if (query.q) {
          history.pushState(query, null, '?q=' + query.q)
        }
        callback(
          data,
          data.pagination.totalNumberOfResults,
          selectedCity,
          null,
          data.pagination.numberOfPages - 1 > data.pagination.currentPage,
          container,
          counter,
          $citySelect,
          null,
          citySummery
        )
      })
    }
  },
  getMoreResults: (callback) => {
    SP.branches.updateQuery(
      SP.branches.query.location,
      isMobile ? SP.branches.query.maxResults : null,
      SP.branches.query.selectedCity,
      SP.branches.query.filters,
      false,
      true
    )

    SP.branches.fetchBranches(SP.branches.getQueryObject(), (data) => {
      callback(
        data.storeList,
        data.pagination.numberOfPages - 1 > data.pagination.currentPage
      )
    })
  },
  updateQuery: (
    location,
    maxRecord,
    selectedCity,
    filters,
    buildFacets,
    nextPage
  ) => {
    SP.branches.query.location = location
    SP.branches.query.maxRecord = maxRecord
    SP.branches.query.selectedCity = selectedCity
    SP.branches.query.filters = filters
    SP.branches.query.buildFacets = buildFacets

    if (nextPage) {
      SP.branches.query.page = SP.branches.query.page + 1
    } else {
      SP.branches.query.page = 0
    }
  },
  updateQueryFromURL: (location, maxResults) => {
    let city = '',
      filters = []
    const queryParams = parseURLQuery()

    if (queryParams.city) {
      city = queryParams.city
    }
    if (queryParams.q || queryParams.av) {
      let queryParamsArr
      if (queryParams.q) {
        queryParamsArr = queryParams.q.split(':')
      } else {
        queryParamsArr = queryParams.av.split(':')
      }
      city = queryParamsArr[0]

      if (queryParamsArr.length > 1) {
        filters = SP.branches.buildFilters(queryParamsArr)
      }
    }

    SP.branches.updateQuery(location, maxResults, city, filters, true, false)
  },
  buildFilters: (queryParamsArr) => {
    let filters = []
    for (let i = 1; i + 1 < queryParamsArr.length; i += 2) {
      filters.push({
        parentCode: queryParamsArr[i],
        code: queryParamsArr[i + 1],
      })
    }
    return filters
  },

  getQueryObject: () => {
    const queryObj = {
      q: SP.branches.query.selectedCity,
      page: SP.branches.query.page,
      maxRecord: SP.branches.query.maxRecord,
      buildFacets: SP.branches.query.buildFacets,
    }

    if (SP.branches.query.location != null) {
      queryObj.longitude = SP.branches.query.location.longitude
      queryObj.latitude = SP.branches.query.location.latitude
    }

    if (SP.branches.query.selectedCity != null) {
      queryObj.selectedCity = SP.branches.query.selectedCity
    }

    let clinic = []
    let service = []
    let brand = []
    let branch = []

    $.each(SP.branches.query.filters, (index, value) => {
      queryObj.q += ':' + value.parentCode + ':' + value.code

      switch (value.parentCode) {
        case 'clinic':
          clinic.push(value.code)
          break
        case 'service':
          service.push(value.code)
          break
        case 'brand':
          brand.push(value.code)
          break
        case 'branch':
          branch.push(value.code)
          break
        default:
          break
      }
    })

    queryObj.clinic = clinic.join(':')
    queryObj.service = service.join(':')
    queryObj.brand = brand.join(':')
    queryObj.branch = branch.join(':')

    return queryObj
  },
  goBack: (previousState, callback) => {
    previousState.page = 0
    SP.branches.fetchBranches(previousState, callback)
  },
}
